export const tests = [{
  path: '/checklists',
  name: 'general.company',
  component: () => import('./Tests.vue'),
  meta: {
    rule: 'QUESTIONNAIRES',
    authRequired: true,
    title: 'general.tests',
    breadcrumb: [
      {
        text: 'general.home',
        disabled: false,
        href: '#/',
      },
      {
        text: 'general.tests',
        disabled: true,
        href: '#/checklists',
      }
    ]
  }
},
{
  path: '/checklists/add',
  name: 'New test',
  component: () => import('./Form.vue'),
  meta: {
    rule: 'QUESTIONNAIRE_CREATE',
    authRequired: true,
    title: 'general.tests',
    breadcrumb: [
      {
        text: 'general.home',
        disabled: false,
        href: '#/',
      },
      {
        text: 'general.tests',
        disabled: false,
        href: '#/checklists',
      },
      {
        text: 'tests.add',
        disabled: true,
        href: '#/checklists',
      }
    ]
  }
},
{
  path: '/checklists/edit/:id',
  name: 'Edit test',
  component: () => import('./Form.vue'),
  meta: {
    rule: 'QUESTIONNAIRE_UPDATE',
    authRequired: true,
    title: 'general.tests',
    breadcrumb: [
      {
        text: 'general.home',
        disabled: false,
        href: '#/',
      },
      {
        text: 'general.tests',
        disabled: false,
        href: '#/checklists',
      },
      {
        text: 'tests.edit',
        disabled: true,
        href: '#/checklists',
      }
    ]
  }
},
{
  path: '/checklists/default_questionnaires',
  name: 'Default Questionnaires',
  component: () => import('./DefaultQuestionnaires.vue'),
  meta: {
    rule: 'QUESTIONNAIRES_DEFAULT_ADD',
    authRequired: true,
    title: 'general.defaultTests',
    breadcrumb: [
      {
        text: 'general.home',
        disabled: false,
        href: '#/',
      },
      {
        text: 'general.tests',
        disabled: false,
        href: '#/checklists',
      },
      {
        text: 'general.defaultTests',
        disabled: true,
        href: '#/checklists',
      }
    ]
  }
}]